import * as marietta3d from '..';

export default class PlanEstimate {
        public gaibu: Array<marietta3d.AutoGen.EstimateValue>;

        public naibu: Array<Array<marietta3d.AutoGen.RoomEstimate>>;

        constructor() {
          this.gaibu = [];
          this.naibu = [];
          this.naibu[0] = [];
          this.naibu[1] = [];
          this.naibu[2] = [];
        }
}
